import { Text, LinkProps } from '@chakra-ui/react'
import * as React from 'react'

import { vw } from '../../styles/theme'
import Button from './Button'
import Link from '../common/Link'
import SVG from '../common/SVG'
import TwitterLogo from '../icons/TwitterLogo'
import usePageColor from '../../hooks/usePageColor'

export type ButtonTextNavProps = LinkProps & {
  ja: string
  en: string
  to: string
}

const ButtonTextNav: React.FC<ButtonTextNavProps> = ({ ja, en, ...others }) => {
  const color = usePageColor()
  return (
    <>
      <Link {...others}>
        <Button
          as="span"
          variant="unstyled"
          role="group"
          lineHeight="1"
          display="inline-flex"
          flexDirection="column"
          alignItems="flex-start"
        >
          {ja === 'twitter' ? (
            <SVG
              as="span"
              w={[vw(15), '15px']}
              h={[vw(12), '12px']}
              svg={<TwitterLogo />}
              mb={[vw(9), '9px']}
              fill={color}
              _groupHover={{
                'svg *': {
                  fill: color,
                },
              }}
            />
          ) : (
            <Text
              as="span"
              color={color}
              fontSize={[vw(13), '12px']}
              mb={[vw(9), '9px']}
              _groupHover={{ color: color }}
            >
              {ja}
            </Text>
          )}
          <Text as="span" color={color === '#333333' ? '#aaaaaa' : color} fontSize={[vw(9), '10px']}>
            {en}
          </Text>
        </Button>
      </Link>
    </>
  )
}

export default ButtonTextNav
